module.exports = __webpack_public_path__ + "img/no-image.220bb530.jpg";